<form [formGroup]="formGroup()" class="row gap-md-0 gap-4">
  <div class="col-12 col-md-6">
  <div class="row gap-4">
    <!-- NAME -->
    <div class="col-sm-12">
      <app-form-input
                      [id]="'name'"
                      [label]="'VEHICLES.NAME' | translate"
                      [controlName]="'name'"
                      [formGroup]="formGroup()"
                      [isRequired]="true"/>
    </div>
    <!-- DESCRIPTION -->
    <div class="col-sm-12">
      <app-text-area-input [id]="'description'"
                           [label]="('DESCRIPTION'|translate)"
                           [controlName]="'description'"
                           [formGroup]="formGroup()"/>
    </div>
    <!-- CAPACITY -->
    <div class="col-sm-12">
      <app-form-input
                      [id]="'capacity'"
                      [label]="'VEHICLES.CAPACITY' | translate"
                      [controlName]="'capacity'"
                      [formGroup]="formGroup()"
                      [isRequired]="true"
                      [type]="'number'"/>
    </div>
    <!-- TYPE-->
    <div class="col-sm-12">
      <app-read-only-input [label]="'VEHICLES.VEHICLE_TYPE'"
                           [value]="castVehicleTypeEnum(formGroup().value.type)|translate"/>
    </div>
    <!-- IS ACTIVE-->
    <div class="col-sm-12">
      <app-checkbox-input [label]="'VEHICLES.IS_ACTIVE'"
                          [id]="'active'"
                          [controlName]="'active'"
                          [formGroup]="formGroup()"
      />
    </div>
  </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="row gap-4">


<!--LOCATION-->
    <div class="col-sm-12">
      <app-link-select
        [controlName]="'location'"
        [formGroup]="formGroup()"
        [id]="'location'"
        [label]="'LOCATIONS.LOCATION' | translate"
        [optionLabelSelector]="[{ selector: 'name' }]"
        [searchService]="locationService"
        [searchValueName]="'name'"
        [baseLink]="'/locations'"
        [queryParams]="[
          { key: 'type', value: 'location' }
          ]"/>
    </div>
      <!--EMPLOYEE-->
      <div class="col-sm-12">
        <app-link-select
          [controlName]="'vitabeneEmployee'"
          [formGroup]="formGroup()"
          [id]="'vitabeneEmployee'"
          [label]="'EMPLOYEES.EMPLOYEE' | translate"
          [optionLabelSelector]="[
          { selector: 'firstName', suffix: ' ' },
          { selector: 'lastName' }]"
          [searchService]="employeeService"
          [searchValueName]="'firstName'"
          [baseLink]="'/employees'"/>
      </div>
      <!-- EMPLOYEE_BREAK_DURATION -->
      <div class="col-sm-12">
        <app-form-input
          [id]="'employeeBreakDuration'"
          [label]="'SETTINGS.EMPLOYEE_BREAK_DURATION' | translate"
          [controlName]="'employeeBreakDuration'"
          [formGroup]="formGroup()"
          [type]="'number'"
        />
      </div>
      <!--EMPLOYEE_START_TIME-->
      <div class="col-sm-12">
        <app-form-input
          [id]="'employeeStartTime'"
          [label]="'SETTINGS.EMPLOYEE_START_TIME' | translate"
          [controlName]="'employeeStartTime'"
          [formGroup]="formGroup()"
          [type]="'hour-minute'"/>
      </div>
      <!--EMPLOYEE_END_TIME-->
      <div class="col-sm-12">
        <app-form-input
          [id]="'employeeEndTime'"
          [label]="'SETTINGS.EMPLOYEE_END_TIME' | translate"
          [controlName]="'employeeEndTime'"
          [formGroup]="formGroup()"
          [type]="'hour-minute'"/>
      </div>
    </div>
  </div>
</form>
